import { message, Select } from 'antd';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { TimerTimeOut } from "../stores/viewsReducer/auth/actions";
import { postApi } from "../../../shared/src/apis";
import helper from '../utils/helper';
import { errorMessage, otpSentSuccessfully } from '../utils/commonStringsConsts';
import { sendOTPApi } from '../utils/apisConsts';
interface props {
    postApi: any,
    TimerTimeOut: any,
    time_out: boolean,
    time: number,
    phone: string,
    twilio?: boolean,
    userLang?: ("ar" | "en")
    setLoading?: any,
    otpModalVisible?: boolean,
}
const { Option } = Select;
class Timer extends Component<props>{
    private timer: any;
    state = {
        time: this.props.time,
        blockedResendOtp: ''
    };

    decrementTimeRemaining = () => {
        if (this.state.time > 0) {
            this.setState({
                time: this.state.time - 1
            });
        } else {
            clearInterval(this.timer!);
            this.props.TimerTimeOut(true);
        }
    };

    componentDidMount() {
        this.props.TimerTimeOut(false);
        this.timer = setInterval(() => {
            this.decrementTimeRemaining();
        }, 1000);
    }

    componentDidUpdate(prevProps: Readonly<props>, prevState: Readonly<{}>, snapshot?: any): void {
        if (this.props.otpModalVisible && this.props.otpModalVisible !== prevProps.otpModalVisible) {
            this.setState({ time: 60 }, () => {
                this.timer = setInterval(() => {
                    this.decrementTimeRemaining();
                }, 1000);
                setTimeout(() => {
                    clearInterval(this.timer);
                    this.props.TimerTimeOut(true);
                }, 30000);
            })
        }
        if (!this.props.otpModalVisible && this.props.otpModalVisible !== prevProps.otpModalVisible) {
            clearInterval(this.timer);
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }
    reSendCode = async (option: (0 | 1 | 2 | 3)) => {
        const info = { phone: this.props.phone };
        this.props.setLoading(true);
        if (option === 0 || option === 3) {
            const response: any = await helper.callApiRequest(sendOTPApi, 'POST', '', info);
            if (response?.data?.status === 200) {
                message.success(otpSentSuccessfully);
                this.setState({ blockedResendOtp: '' })
                this.reTimer();
            } else {
                message.error(response?.data?.message ?? errorMessage);
                this.setState({ blockedResendOtp: response?.data?.message ?? errorMessage })
            }
        }
        else {
            const res: any = await helper.sendOtpTwilio(this.props.phone, option, this.props.userLang ? this.props.userLang : "en")
            if (res.status === 200) {
                message.success(res.message);
                this.reTimer()
            }
            else {
                message.error(res.message)
            }
        }

        this.props.setLoading(false)

    }
    reTimer = () => {
        this.setState({ time: 60 })
        this.props.TimerTimeOut(false);
        this.timer = setInterval(() => {
            this.decrementTimeRemaining();
        }, 1000);
    }
    render() {
        const { time } = this.state;
        const { time_out, twilio } = this.props;

        return (
            <div>
                <div className="timer">
                    {!time_out && <p className={'counter'} style={{ padding: '0 17px' }}>(00 : {time >= 10 ? time : ` 0${time}`})</p>}
                    {time_out && !this.state.blockedResendOtp && <p style={{ padding: '0 17px' }} className='asking'>Didn't get the code?</p>}
                    {time_out &&
                        <>
                            {this.state.blockedResendOtp ?
                                <p className='timeOut'>{this.state.blockedResendOtp}</p>
                                : <div style={{ padding: '0 17px' }}>
                                    {twilio ?
                                        <div className='options'>
                                            <span>Resend OTP via</span>
                                            <Select
                                                placeholder="Select an option"
                                                onChange={this.reSendCode}
                                            >
                                                <Option value={0}>SMS</Option>
                                                <Option value={1}>WhatsApp</Option>
                                                {/* <Option value={2}>Voice Call</Option> */}
                                                <Option value={3}>SMS via Amazon</Option>
                                            </Select>
                                        </div>
                                        : <>
                                            <h4 className='resending' onClick={() => this.reSendCode(0)}>Resend Code</h4>
                                            <h4 className='resending' style={{ fontWeight: 600 }} onClick={() => this.reSendCode(1)}>Resend Code via WhatsApp</h4>
                                        </>}

                                </div>}
                        </>
                    }
                </div>
            </div>
        )
    }
}
const mapStateToProp = (state: any) => ({
    time_out: state.auth.time_out,
    otpModalVisible: state.actionsReducer.otpModalVisible

})
export default connect(mapStateToProp, { TimerTimeOut, postApi })(Timer)
